export default "<spec-app-type1-string-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type1-string-table>\n";